import {IPoint} from "../interfaces/IPoint";

export class Direction {

    id: string;
    point: IPoint;


    constructor(id: string, point: IPoint) {
        this.id = id;
        this.point = point;
    }
}
